// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1DvSg","topBottomGutter":"Layout_topBottomGutter__1pryD"};